import { useEventListener } from '@vueuse/core'

/**
 * Reactive flag indicating whether the current viewport width is below the provided breakpoint.
 * To be used only when the desired outcome cannot be achieved with CSS media queries.
 * Runs only on the client – safe to call during SSR (it will just return a false ref until hydrated).
 *
 * @param breakpoint Number (px) to compare against. Defaults to BREAKPOINTS.desktopXL.
 * @returns Ref<boolean> isMobile
 */
export function useIsMobile(breakpoint: number = BREAKPOINTS.desktopXL) {
  const isMobile = ref(false)

  if (import.meta.server) {
    return isMobile
  }

  const update = () => {
    isMobile.value = window.innerWidth < breakpoint
  }
  onBeforeMount(update)
  // Listen for resize events (auto cleaned up by vueuse on unmount)
  useEventListener(window, 'resize', update)

  return isMobile
}
